jQuery(function () {

	// Don't run if we are not one of the
	// WPM main tabs
	if ("pmw" !== pmwGetPageId()) return

	let sections    = []
	let subsections = {}

	// Hide unnecessary elements
	jQuery(".section").closest("tr").hide()

	// Collect information on sections
	jQuery(".section").each(function () {
		sections.push({
			"slug"          : jQuery(this).data("sectionSlug"),
			"title"         : jQuery(this).data("sectionTitle"),
			"badgeCount"    : jQuery(this).data("badgeCount") || 0,
			"priority"      : parseInt(jQuery(this).data("priority"), 10) || 50,
			"showSaveButton": jQuery(this).data("showSaveButton"),
		})
	})

	// Sort sections by priority (ascending)
	sections.sort(function (a, b) {
		return a.priority - b.priority
	})

	// Collect information on subsections
	jQuery(".subsection").each(function () {

		subsections[jQuery(this).data("sectionSlug")] = subsections[jQuery(this).data("sectionSlug")] || []

		subsections[jQuery(this).data("sectionSlug")].push({
			"title": jQuery(this).data("subsectionTitle"),
			"slug" : jQuery(this).data("subsectionSlug"),
		})
	})

	// Create tabs for sections
	sections.forEach(
		function (section) {
			let badge = section["badgeCount"] > 0 ? "<span class=\"pmw-tab-badge\">" + section["badgeCount"] + "</span>" : ""
			jQuery(".nav-tab-wrapper").append("<a href=\"#\" class=\"nav-tab\" data-section-slug=\"" + section["slug"] + "\">" + section["title"] + badge + "</a>")
		})

	// Create tabs for each subsections
	jQuery(".nav-tab-wrapper").after(pmwCreateSubtabUlHtml(subsections))

	// Create on-click events on section tabs that toggle the views
	jQuery(".nav-tab-wrapper a").on("click", function (e) {

		e.preventDefault()

		// show clicked tab as active
		jQuery(this).addClass("nav-tab-active").siblings().removeClass("nav-tab-active")

		// toggle the sections visible / invisible based on clicked tab

		let sectionSlug = jQuery(this).data("section-slug")
		pmwToggleSections(sectionSlug, sections)

		// if subsection exists, click on first subsection
		if (sectionSlug in subsections) {
			jQuery("ul[data-section-slug=" + sectionSlug + "]").children(":first").trigger("click")
		}
	})

	// Create on-click events on subsection tabs that toggle the views
	jQuery(".pmw-subnav-li").on("click", function (e) {

		e.preventDefault()
		e.stopPropagation()

		// jQuery(this).hide();
		jQuery(this)
			.addClass("pmw-subnav-li-active").removeClass("pmw-subnav-li-inactive")
			.siblings()
			.addClass("pmw-subnav-li-inactive").removeClass("pmw-subnav-li-active")

		pmwToggleSubsection(jQuery(this).parent().data("section-slug"), jQuery(this).data("subsection-slug"))
	})

	/**
	 * If someone accesses a plugin tab by deep link, open the right tab
	 * or fallback to default (first tab)
	 *
	 * If deeplink is being opened,
	 * open the according section and subsection
	 */
	if (pmwGetSectionParams()) {

		let sectionParams = pmwGetSectionParams()

		jQuery("a[data-section-slug=" + sectionParams["section"] + "]").trigger("click")

		if (sectionParams["subsection"] !== false) {
			jQuery("ul[data-section-slug=" + sectionParams["section"] + "]").children("[data-subsection-slug=" + sectionParams["subsection"] + "]").trigger("click")
		}
	} else {
		jQuery("a[data-section-slug=" + sections[0]["slug"] + "]").trigger("click")
	}
})

// Creates the html with all subsection elements
pmwCreateSubtabUlHtml = (subsections) => {

	let subsectionsKeys = Object.keys(subsections)

	let html = ""

	subsectionsKeys.forEach(function (subsectionKey) {
		html += "<ul class=\"pmw-subnav-tabs\" data-section-slug=\"" + subsectionKey + "\">"

		let subtabs = subsections[subsectionKey]

		subtabs.forEach(function (subtab) {
			html += "<li class=\"pmw-subnav-li pmw-subnav-li-inactive\" style=\"cursor: pointer;\" data-subsection-slug=\"" + subtab["slug"] + "\">" + subtab["title"] + "</li>"
		})

		html += "</ul>"
	})

	return html
}

/**
 * If section (and subsection) URL parameters are set,
 * return them, otherwise return false
 */
pmwGetSectionParams = () => {

	const queryString = window.location.search
	const urlParams   = new URLSearchParams(queryString)

	if (urlParams.get("section")) {
		return {
			"section"   : urlParams.get("section"),
			"subsection": urlParams.get("subsection"),
		}
	} else {
		return false
	}
}

// Toggles the sections
pmwToggleSections = (sectionSlug, sections) => {

	jQuery("#pmw_settings_form > h2").nextUntil(".submit").andSelf().hide()
	jQuery(".pmw-subnav-tabs").hide()
	jQuery(".pmw-subnav-tabs[data-section-slug=" + sectionSlug + "]").show()

	let sectionPos = sections.findIndex((arrayElement) => arrayElement["slug"] === sectionSlug)

	jQuery("div[data-section-slug=" + sectionSlug + "]").closest("table").prevAll("h2:first").next().nextUntil("h2, .submit").andSelf().show()

	// set the URL with the active tab parameter
	pmwSetUrl(sections[sectionPos]["slug"])
}

pmwToggleSubsection = (sectionSlug, subsectionSlug) => {

	jQuery("#pmw_settings_form > h2").nextUntil(".submit").andSelf().hide()
	jQuery("[data-section-slug=" + sectionSlug + "][data-subsection-slug=" + subsectionSlug + "]").closest("tr").siblings().andSelf().hide()

	jQuery("[data-section-slug=" + sectionSlug + "][data-subsection-slug=" + subsectionSlug + "]").closest("table").show()
	jQuery("[data-section-slug=" + sectionSlug + "][data-subsection-slug=" + subsectionSlug + "]").closest("tr").nextUntil(jQuery("[data-section-slug=" + sectionSlug + "][data-subsection-slug]").closest("tr")).show()

	// Set the URL with the active tab parameter
	pmwSetUrl(sectionSlug, subsectionSlug)
}

// Sets the new URL parameters
pmwSetUrl = (sectionSlug, subsectionSlug = "") => {

	const queryString = window.location.search
	const urlParams   = new URLSearchParams(queryString)

	// Preserve the theme switcher param across tab navigation
	const pmwTheme = urlParams.get("pmw_theme")

	urlParams.delete("section")
	urlParams.delete("subsection")

	let newParams = "section=" + sectionSlug
	newParams += subsectionSlug ? "&subsection=" + subsectionSlug : ""
	newParams += pmwTheme ? "&pmw_theme=" + pmwTheme : ""

	history.pushState("", "pmw" + sectionSlug, document.location.pathname + "?page=pmw&" + newParams)

}

pmwGetPageId = () => {

	const queryString = window.location.search
	const urlParams   = new URLSearchParams(queryString)

	return urlParams.get("page")
}

// On click of an element that contains a data-section-slug with any value, toggle save button
jQuery(document).on("click", "[data-section-slug]", function () {

	// Find the section config to check showSaveButton attribute
	const sectionSlug = jQuery(this).data("sectionSlug") || jQuery(this).data("section-slug")
	const $sectionDiv = jQuery(".section[data-section-slug='" + sectionSlug + "']")

	if ($sectionDiv.length && $sectionDiv.data("showSaveButton") == 0) {
		jQuery(".submit").hide()
	} else {
		jQuery(".submit").show()
	}
})


// if a link with the class advanced-section-link is clicked,
// get the data-AS-section and the data-AS-subsection values of the clicked element
// and trigger a click on the element with the data-ssection-slug value and a click on the element with the data-subsection-slug value
jQuery(document).on("click", ".advanced-section-link", (e) => {

	e.preventDefault()

	let sectionSlug    = jQuery(e.currentTarget).data("as-section")
	let subsectionSlug = jQuery(e.currentTarget).data("as-subsection")

	jQuery(`a[data-section-slug=${sectionSlug}]`).trigger("click")

	jQuery(`ul[data-section-slug=${sectionSlug}]`).children(`[data-subsection-slug=${subsectionSlug}]`).trigger("click")
})
